export const BULK_QUEUE_THRESHOLD = 20;
export function selectEventGuests(guests, { status = '', group = '', shuttleOnly = false, guestIds = null } = {}) {
    return (guests || []).filter((guest) => (!status || guest.rsvp_status === status)
        && (!group || guest.group_id === group) && (!shuttleOnly || guest.needs_shuttle)
        && (!guestIds || guestIds.includes(guest.id)));
}
export function bulkProgress(rows = []) {
    const count = (status) => rows.filter((row) => row.status === status).length;
    return { total: rows.length, sent: count('sent'), skipped: count('skipped'), failed: count('failed'), uncertain: count('uncertain'),
        remaining: count('queued') + count('sending'), canceled: count('canceled') };
}
export async function enqueueBulk(client, payload) {
    const { data, error } = await client.functions.invoke('comms-bulk', { body: { action: 'enqueue', ...payload } });
    if (error || !data?.ok) throw new Error(data?.error || error?.message || 'The send could not be queued.');
    return data;
}

export function bulkConsentReason(contact, channel, messageType) {
    if (channel === 'sms' && contact?.sms_opted_out_at) return 'sms_opted_out';
    if (channel === 'email' && contact?.email_opted_out_at) return 'email_opted_out';
    if (messageType !== 'campaign') return '';
    const offers = contact?.communication_preferences?.offers_news;
    const consent = channel === 'email' ? offers?.enabled && offers?.by_email
        : offers ? offers.enabled && offers.by_text : contact?.sms_marketing_consent;
    return consent ? '' : 'missing_marketing_consent';
}
/** Map both daily/departure manifests and split arrival-party allocations back to event guests. */
export function eventGuestsForTrip(tripId, { waves = [], riders = [], passengers = [], allocations = [] } = {}) {
    const waveIds = new Set(waves.filter((wave) => wave.trip_id === tripId).map((wave) => wave.id));
    return [...new Set([
        ...riders.filter((rider) => waveIds.has(rider.wave_id)).map((rider) => rider.event_guest_id),
        ...allocations.filter((allocation) => waveIds.has(allocation.wave_id)).flatMap((allocation) => passengers
            .filter((passenger) => passenger.party_id === allocation.party_id && passenger.position >= allocation.passenger_offset
                && passenger.position < allocation.passenger_offset + allocation.passenger_count)
            .map((passenger) => passenger.event_guest_id)),
    ].filter(Boolean))];
}
